import Action from 'constants/action-types'
import {
  SET_API_KEYS,
  SET_FETCHING_API_KEYS,
  SET_CREATING_API_KEY,
} from 'constants/action-types'
import type { ApiKeysState } from 'types/settings/api-keys'

const initialState: ApiKeysState = {
  items: [],
  isFetching: false,
  isCreating: false,
}

export default (
  state: ApiKeysState = initialState,
  action: Action,
): ApiKeysState => {
  switch (action.type) {
    case SET_API_KEYS:
      return {
        ...state,
        items: action.payload as ApiKeysState['items'],
      }

    case SET_FETCHING_API_KEYS:
      return {
        ...state,
        isFetching: action.payload,
      }

    case SET_CREATING_API_KEY:
      return {
        ...state,
        isCreating: action.payload,
      }

    default:
      return state
  }
}
